<div class="added-bg d-flex flex-column align-items-center text-center">
    <!--    <ng-lottie [options]="{ path: './assets/lottie/404-error.json', loop: false, autoplay: true }" width="700px" height="auto" containerClass="mx-auto mw-100"></ng-lottie>-->
    <div class="margin-top-div">
        <h1 class="mb-2 fw-semibold">Sorry, You Can’t View This Page</h1>
        <p class="mb-3" style="font-size: 13px !important;">You do not have required permissions to view the page you are looking for.</p>
        <br />
        <div class="d-flex">
            <button class="btn btn-warning d-inline-flex align-items-center px-4 fs-13 me-3" (click)="goBack()">
                Go Back
                <span class="iconify ms-2" data-icon="carbon:home" style="font-size: 20px"></span>
            </button>
            <button class="btn btn-info btn-lg d-inline-flex align-items-center px-4 fs-13" (click)="goBackHome()">
                Main Menu
                <span class="iconify ms-2" data-icon="carbon:home" style="font-size: 20px"></span>
            </button>
        </div>
    </div>

    <img class="img-wrapper" src="/assets/images/smart-lga-large.png"/>

</div>